import { render, staticRenderFns } from "./BaseTooltip.vue?vue&type=template&id=d847b70c&scoped=true&"
import script from "./BaseTooltip.vue?vue&type=script&lang=ts&"
export * from "./BaseTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTooltip.vue?vue&type=style&index=0&id=d847b70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d847b70c",
  null
  
)

export default component.exports